const contentEn = {
  "sections": [
    {
      "title": "‌PROCESSING OF YOUR DATA",
      "content": [
        {
          "type": "p",
          "content": [
            {
              "type": "span",
              "content": "We attach great importance to protecting your privacy and your data. We are committed to offering the highest standards in terms of products and services. We value each of our existing and potential customers and aim to maintain appropriate protection of your personal data (\""
            },
            {
              "type": "b",
              "content": "Data"
            },
            {
              "type": "span",
              "content": "\")."
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "span",
                  "content": "The processing of this Data is carried out in accordance with the provisions of Regulation (EU) of the European Parliament and of the Council of April 27, 2016 (hereinafter referred to as"
                },
                {
                  "type": "b",
                  "content": "the"
                },
                {
                  "type": "span",
                  "content": "\""
                },
                {
                  "type": "b",
                  "content": "GDPR"
                },
                {
                  "type": "span",
                  "content": "\") and French Law No. 78-17 of January 6, 1978 (\""
                },
                {
                  "type": "b",
                  "content": "Data Protection Act"
                },
                {
                  "type": "span",
                  "content": "\")."
                }
              ]
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            }
          ]
        },
        {
          "type": "list_ordered",
          "content": [
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHO IS RESPONSIBLE FOR DATA PROCESSING?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "STRAGILIA, publisher of the website "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://www.stragilia.com/",
                      "content": "https://www.stragilia.com/"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": " (hereinafter the \""
                },
                {
                  "type": "b",
                  "content": "Website"
                },
                {
                  "type": "span",
                  "content": "\"), is the Data Controller (hereinafter the \""
                },
                {
                  "type": "b",
                  "content": "Data Controller"
                },
                {
                  "type": "span",
                  "content": "\")."
                },
                {
                  "type": "span",
                  "content": "By using the Website, you consent to and accept the use of your Data by the Data Controller in accordance with this Privacy Policy."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT DATA IS COLLECTED?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "During your exchanges with customer service and, more generally, when you browse our Site, the Data Controller processes your information, some of which may identify you."
                },
                {
                  "type": "span",
                  "content": "This may include the following Data:"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "list_unordered",
                  "content": [
                    "Data that you have provided to us directly: your surname; first names; postal address; email address; telephone number; username and encrypted password enabling you to log in to the Website; and your contact preferences regarding subscription to our newsletter.",
                    "Data collected automatically (cookies): IP address and computer equipment identifiers; operating system used by the terminal; type and version of browser software used; date and time of connection to the site.",
                    "Data collected when you browse the Site: your browsing history (e.g., date, time of connection and/or browsing, pages visited), type of device and browser, your location, browser language, internet service provider, IP address."
                  ]
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "We do not collect sensitive data such as racial or ethnic origin, political, philosophical or religious opinions, trade union membership, data relating to health, sex life or offenses, convictions and security measures."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT ARE THE PURPOSES OF THE PROCESSING?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Your Data is used for several reasons, including to provide and improve the services and products we offer you."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Each processing of your Data is legally based either on your consent, or on a contract concluded with you, or on a legal obligation and/or our legitimate interest depending on the purpose of the processing."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "table",
                  "content": {
                    "headers": [
                      "Purposes of processing",
                      "Legal basis"
                    ],
                    "rows": [
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Ensuring the use of the products and services provided by the Site",
                              "Manage customer relations and any complaints you may have",
                              "Manage requests related to the exercise of your rights regarding Personal Data"
                            ]
                          }
                        ],
                        "col2": "A contract"
                      },
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Enjoy a personalized browsing experience based on your purchase history and your browsing on the Site"
                            ]
                          }
                        ],
                        "col2": "Your consent"
                      },
                      {
                        "col1": [
                          {
                            "type": "list_unordered",
                            "content": [
                              "Accessing and using the Site",
                              "Analyzing and improving the quality and performance of services",
                              "Monitoring use of the Site and improving your experience",
                              "Preserve our rights",
                              "Manage transactions and combat fraud",
                              "Develop statistics and segmentations, studies, and analyses to improve our knowledge of our customers"
                            ]
                          }
                        ],
                        "col2": "Our legitimate interest"
                      }
                    ]
                  }
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHO ARE THE RECIPIENTS OF YOUR DATA?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "The Data is mainly intended for the Data Controller, its employees for the purposes mentioned in Article 3, as well as the following subcontractors:"
                },
                {
                  "type": "span",
                  "content": "The hosting provider: Google Cloud Platform (GCP). These services are provided and managed by Google Ireland Limited, a company registered in Ireland under registration number 368047."
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "b",
                  "content": "Address of Google Ireland Limited:"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "Gordon House, Barrow Street,"
                    },
                    {
                      "type": "br",
                      "content": ""
                    },
                    {
                      "type": "span",
                      "content": "Dublin 4, Ireland."
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        [
                          "Payment providers: STRIPE."
                        ]
                      ]
                    },
                    {
                      "type": "p",
                      "content": "Details of how this Data is processed by the providers are available at the following links: Hosting provider: Google Cloud Platform (GCP). These services are provided and managed by Google Ireland Limited, a company registered in Ireland under registration number 368047."
                    },
                    {
                      "type": "b",
                      "content": "Address of Google Ireland Limited:"
                    },
                    {
                      "type": "br",
                      "content": ""
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "span",
                          "content": "Gordon House, Barrow Street,"
                        },
                        {
                          "type": "p",
                          "content": "Dublin 4, Ireland."
                        }
                      ]
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        {
                          "type": "span",
                          "content": [
                            {
                              "type": "span",
                              "content": "Payment provider"
                            },
                            {
                              "type": "list_unordered",
                              "content": [
                                {
                                  "type": "span",
                                  "content": [
                                    {
                                      "type": "span",
                                      "content": "STRIPE : "
                                    },
                                    {
                                      "type": "a",
                                      "href": "https://stripe.com/privacy",
                                      "content": "https://stripe.com/privacy"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                      ]
                    },
                    {
                      "type": "p",
                      "content": "The Data Controller undertakes not to disclose, transfer, or transfer the Data to other third parties without your express consent. However, it may be disclosed to comply with legal, regulatory, judicial, or administrative obligations."
                    }
                  ]
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌HOW LONG DO WE KEEP YOUR DATA?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Data is kept for as long as necessary to fulfill the aforementioned purposes, without the retention period exceeding two (2) years from the last interaction with the Site. The Data Controller takes reasonable measures to ensure their confidentiality."
                },
                {
                  "type": "span",
                  "content": "Once your Data has been deleted from our database, some of your Data may be kept in an archive with restricted and strictly limited access for the purposes of complying with our legal, accounting, and tax obligations, but also to manage any complaints and warranty claims you may have within the applicable limitation periods."
                },
                {
                  "type": "span",
                  "content": "Once your Data is no longer necessary for the purposes or for archiving purposes to meet our legal obligations or for the purposes of the applicable limitation period, your Data will be irreversibly anonymized."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "At any time, you may ask us to delete all or part of your Data, object to its processing, or request its limitation, in accordance with Article 4 above. If you request the deletion of your Data, it will be deleted from our database and stored in an archive as indicated above."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT ARE YOUR RIGHTS WITH REGARD TO YOUR DATA?"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "In accordance with the French Data Protection Act and the GDPR, you have and can exercise the following rights with us:"
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        "Right of access: you have the right to know what Data we hold about you.",
                        "Right of rectification: you may request the rectification of inaccurate or incomplete information concerning you. This prevents us from using or disseminating incorrect information about you.",
                        "Right to erasure: you have the right to ask us to delete your Data (subject to the terms set out in Article 8 below).",
                        "Right to object: you may object at any time to our use of certain Data about you.",
                        "Right to portability: you have the option of retrieving some of your Data in a machine-readable format. You are free to store this portable Data elsewhere or easily transfer it from one system to another for reuse for other purposes.",
                        "Right to information: you have the right to be informed about the use of your Data."
                      ]
                    }
                  ]
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "You can exercise your rights by contacting the Data Controller:"
                },
                [
                  {
                    "type": "list_unordered",
                    "content": [
                      {
                        type: "span",
                        content: [
                          {
                            type: "span",
                            content: "By email at: "
                          },
                          {
                            type: "a",
                            href: "mailto:contact@stragilia.com",
                            content: "contact@stragilia.com",
                          }
                        ]
                      },
                      "By mail at the postal address: STRAGILA 6 rue d'Armaillé 75017 PARIS France."
                    ]
                  },
                  {
                    "type": "p",
                    "content": [
                      {
                        "type": "p",
                        "content": ""
                      }
                    ]
                  },
                  {
                    "type": "p",
                    "content": [
                      {
                        "type": "p",
                        "content": ""
                      }
                    ]
                  },
                  {
                    "type": "br",
                    "content": ""
                  },
                  {
                    "type": "p",
                    "content": [
                      {
                        "type": "span",
                        "content": "The Data Controller hosts the Website with a specialized service provider, Google Cloud Platform (GCP). These services are provided and managed by Google Ireland Limited, whose information is contained in the Legal Notice."
                      }
                    ]
                  },
                  {
                    "type": "p",
                    "content": [
                      {
                        "type": "p",
                        "content": ""
                      }
                    ]
                  }
                ]
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌HOW IS DATA SECURED?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "The Data Controller undertakes to take all technical and organizational measures to ensure the protection and security of the Data, in particular against any loss, alteration, dissemination, or illegal use."
                },
                {
                  "type": "span",
                  "content": "It also ensures that any third parties it may use (technical service providers, suppliers) comply with this data protection requirement by implementing appropriate measures in accordance with applicable legislation. The technical and organizational measures put in place may include the use of secure registration forms, the encryption of certain Data (such as banking Data), and restricted access to Personal Data."
                },
                {
                  "type": "span",
                  "content": "Finally, we urge you to exercise the utmost caution when communicating your Data, usernames, and personal passwords that allow access to the Site."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Some messages or solicitations you receive may come from malicious individuals seeking to obtain your personal information"
                },
                {
                  "type": "span",
                  "content": "for"
                },
                {
                  "type": "span",
                  "content": "fraudulent purposes (phishing). If you receive a message that appears to be a phishing attempt, you are advised not to respond to it and not to open any attachments, images, or links contained in the message. You can report it by email to "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "mailto:contact@stragilia.com",
                      "content": "contact@stragilia.com"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": " and on "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://www.signal-spam.fr/",
                      "content": "www.signal-spam.fr."
                    }
                  ]
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌TRANSFER OF PERSONAL DATA"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "The Site is hosted by Google Cloud Platform (GCP) on physical servers in France and Belgium. The Data is processed via various software and applications by the Data Controller. This software and these applications are hosted on secure servers in Europe under conditions that comply with applicable regulations."
                },
                {
                  "type": "span",
                  "content": "In the event that Data is transferred to a country outside the European Union, we undertake to take the necessary technical and organizational measures to ensure the adequate level of security of your Data as if it had remained within the European Union."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌CHANGES TO THE PRIVACY POLICY"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "If this Privacy Policy is amended, the date of the Policy update will be updated and will indicate the day on which the amendments were made."
                },
                {
                  "type": "span",
                  "content": "If the changes are significant, you will be notified by email. The new version will apply from the moment you next log on to the Site."
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "In the event of a dispute between you and the Data Controller, the Policy to be taken into account will be the one in force at the time of the events giving rise to the dispute."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌CONTACT"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "In general, if you have any questions or comments about this Policy or the use of your Data by the Data Controller, you can contact us at the following address: STRAGILA 6 rue d’Armaillé 75017 PARIS France"
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "p",
                          "content": ""
                        }
                      ]
                    },
                    {
                      "type": "p",
                      "content": [
                        {
                          "type": "span",
                          "content": "Finally, we would like to point out that if you have any complaints regarding the protection of your Personal Data, you can also contact the French supervisory authority, the Commission Nationale de l’Informatique et des Libertés (CNIL), whose website can be accessed at the following address: "
                        },
                        {
                          "type": "span",
                          "content": [
                            {
                              "type": "a",
                              "href": "https://www.cnil.fr/",
                              "content": "https://www.cnil.fr/"
                            }
                          ]
                        },
                        {
                          "type": "span",
                          "content": "."
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "title": "‌COOKIES",
      "content": [
        {
          "type": "p",
          "content": [
            {
              "type": "span",
              "content": "When you browse our website at "
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "a",
                  "href": "https://www.stragilia.com/",
                  "content": "https://www.stragilia.com/"
                }
              ]
            },
            {
              "type": "span",
              "content": " (the \"Site\"), browsing data may be collected, with your prior consent where necessary, from cookies placed on our Site. During their lifetime, these cookies will improve your experience. The purpose of this section is to provide you with clear and comprehensive information on the origin and use of cookies that are placed on your device (desktop or mobile computer, tablet, smartphone, etc.) when you visit our Site and on the means available to you if you wish to object to them."
            },
            {
              "type": "p",
              "content": [
                {
                  "type": "p",
                  "content": ""
                }
              ]
            }
          ]
        },
        {
          "type": "list_ordered",
          "content": [
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT IS A COOKIE?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "A"
                },
                {
                  "type": "span",
                  "content": "cookie"
                },
                {
                  "type": "span",
                  "content": "(or \"tracker\") is a small computer file that is stored and read when you visit a website. The term"
                },
                {
                  "type": "span",
                  "content": "cookie"
                },
                {
                  "type": "span",
                  "content": "covers, for example, HTTP"
                },
                {
                  "type": "span",
                  "content": "cookies"
                },
                {
                  "type": "span",
                  "content": ", flash"
                },
                {
                  "type": "span",
                  "content": "cookies"
                },
                {
                  "type": "span",
                  "content": ", fingerprinting results, invisible pixels, or any other identifier generated by software or an operating system."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT ARE THE FUNCTIONS OF COOKIES?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "There are several types of cookies stored on the Website, each serving a different purpose:"
                },
                {
                  "type": "p",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Technical cookies"
                },
                {
                  "type": "span",
                  "content": "(including audience measurement cookies): these allow us to know whether or not you are logged into your customer account or reserved area, manage your selection of products or services, etc. The site may also use statistical and audience measurement cookies to determine the number of visitors and the sections visited."
                },
                {
                  "type": "span",
                  "content": "Optional cookies"
                },
                {
                  "type": "span",
                  "content": ": These are intended to improve the user experience and facilitate user searches by offering products and offers related to their interests."
                },
                {
                  "type": "span",
                  "content": "Advertising cookies"
                },
                {
                  "type": "span",
                  "content": ": if you accept them, they allow us to display advertisements on the web pages you visit that are tailored and personalized to your profile and interests on third-party websites with advertising space. To this end, we may share your browsing data with our partners, including social networks. These advertisements will be offered to you based on, for example, your browsing history, your purchases, or your location data."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌HOW TO SET YOUR COOKIES?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Apart from cookies that are strictly necessary for the functioning of the Site, you can decide at any time to accept or refuse all or part of"
                },
                {
                  "type": "span",
                  "content": "the cookies"
                },
                {
                  "type": "span",
                  "content": "."
                },
                {
                  "type": "span",
                  "content": "To manage your cookies, youcan access our cookie settings tool "
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "a",
                      "href": "https://stragilia.com/cookies",
                      "content": "https://stragilia.com/cookies"
                    }
                  ]
                },
                {
                  "type": "span",
                  "content": [
                    {
                      "type": "span",
                      "content": " directly in these supported browsers:"
                    },
                    {
                      "type": "list_unordered",
                      "content": [
                        "Safari",
                        "Chrome",
                        "Firefox",
                        "Edge / Internet Explorer",
                        "iOS"
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌HOW LONG DOES YOUR CONSENT TO COOKIES LAST?"
                },
                {
                  "type": "br",
                  "content": ""
                },
                {
                  "type": "span",
                  "content": "Your consent to the use of cookies is valid for six (6) months from the date of your choice. At the end of this period, we will ask you to renew your consent. If you have not made a choice, we may ask you again to confirm your intentions. In any case, you can withdraw your consent at any time using our cookie settings tool."
                },
                {
                  "type": "p",
                  "content": ""
                }
              ]
            },
            {
              "type": "span",
              "content": [
                {
                  "type": "b",
                  "content": "‌WHAT ARE THE CONSEQUENCES IF YOU REFUSE COOKIES?"
                },
                {
                  "type": "p",
                  "content": [
                    {
                      "type": "span",
                      "content": "By configuring your cookies in the settings tool or in your browser, you may change your browsing experience on the Site and no longer be able to take advantage of certain features. For example, by refusing performance and personalization cookies, your browsing experience on the Site will no longer be tailored to your preferences, particularly with regard to the products you have viewed. We also decline all responsibility for any browsing difficulties you may encounter following your decision to delete Cookies."
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]
    }
  ],
  lastUpdated: "Last updated: [01/01/2025]",
};

export default contentEn
